// Mock data for Stiletto Nails on the Beach

export const businessInfo = {
  name: "Stiletto Nails on the Beach",
  tagline: "Miami Beach's Premier Nail Destination",
  address: "7449 Collins Avenue, Miami Beach, FL 33141",
  phone: "+1 (786) 423-3723",
  email: "info@stilettonailsbeach.com",
  hours: {
    weekdays: "Monday - Friday: 9:00 AM - 6:00 PM",
    weekend: "Saturday - Sunday: Closed"
  },
  rating: 4.8,
  reviewCount: 38,
  features: ["Walk-ins Welcome", "Women-Owned", "Latino-Owned", "Free Wi-Fi", "Accessible"]
};

export const services = [
  {
    id: 1,
    category: "Manicures",
    items: [
      { name: "Regular Manicure", price: 25, duration: "30 min", description: "Classic nail care with polish" },
      { name: "Gel Manicure", price: 40, duration: "45 min", description: "Long-lasting gel polish" },
      { name: "Russian Manicure", price: 55, duration: "60 min", description: "Precision dry manicure technique" },
      { name: "Dip Powder Manicure", price: 50, duration: "60 min", description: "Durable powder dip system" },
      { name: "Builder Gel Manicure", price: 60, duration: "75 min", description: "Strengthening gel overlay" }
    ]
  },
  {
    id: 2,
    category: "Pedicures",
    items: [
      { name: "Essential Pedicure", price: 35, duration: "45 min", description: "Basic foot care and polish" },
      { name: "Gel Pedicure", price: 50, duration: "60 min", description: "Premium pedicure with gel polish" },
      { name: "Deluxe Pedicure", price: 65, duration: "75 min", description: "Extended care with massage" },
      { name: "Luxury Volcano Pedicure", price: 85, duration: "90 min", description: "Ultimate spa experience with volcano fizz" }
    ]
  },
  {
    id: 3,
    category: "Extensions & Specialty",
    items: [
      { name: "Acrylic Full Set", price: 70, duration: "90 min", description: "Classic acrylic extensions" },
      { name: "Gel X Apres", price: 80, duration: "90 min", description: "Soft gel tip extensions" },
      { name: "Jelly SPA BATH", price: 45, duration: "30 min", description: "Luxurious jelly pedicure soak" },
      { name: "Nail Art (per nail)", price: 5, duration: "varies", description: "Custom nail designs" }
    ]
  },
  {
    id: 4,
    category: "Packages",
    items: [
      { name: "Mani + Pedi Combo", price: 55, duration: "90 min", description: "Regular manicure and pedicure" },
      { name: "Gel Combo", price: 85, duration: "120 min", description: "Gel manicure and pedicure" },
      { name: "Luxury Spa Day", price: 140, duration: "180 min", description: "Deluxe mani, luxury pedi, and nail art" }
    ]
  }
];

export const gallery = [
  {
    id: 1,
    url: "https://customer-assets.emergentagent.com/job_nails-motion/artifacts/2tyigdmx_IMG_0592.jpeg",
    alt: "Stiletto Nails salon with pink neon sign and rose decorations",
    category: "salon"
  },
  {
    id: 2,
    url: "https://customer-assets.emergentagent.com/job_nails-motion/artifacts/irybngwd_IMG_0593.jpeg",
    alt: "Collection of nail art designs - pink, burgundy, and elegant styles",
    category: "nail-art"
  },
  {
    id: 3,
    url: "https://images.pexels.com/photos/34835286/pexels-photo-34835286.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Black and gold nail art",
    category: "nail-art"
  },
  {
    id: 4,
    url: "https://images.pexels.com/photos/34871614/pexels-photo-34871614.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Pink glitter nails",
    category: "nail-art"
  },
  {
    id: 5,
    url: "https://images.unsplash.com/photo-1690749138086-7422f71dc159?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHw0fHxtYW5pY3VyZXxlbnwwfHx8fDE3ODAwMTcwNTF8MA&ixlib=rb-4.1.0&q=85",
    alt: "Professional manicure service",
    category: "service"
  },
  {
    id: 6,
    url: "https://images.unsplash.com/photo-1604654894610-df63bc536371?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxuYWlsJTIwYXJ0fGVufDB8fHx8MTc4MDAxNzA1MXww&ixlib=rb-4.1.0&q=85",
    alt: "Artistic nail design",
    category: "nail-art"
  },
  {
    id: 7,
    url: "https://images.pexels.com/photos/161737/pedicure-massage-therapist-spa-161737.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Luxury pedicure spa treatment",
    category: "service"
  },
  {
    id: 8,
    url: "https://images.unsplash.com/photo-1632345031435-8727f6897d53?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwxfHxuYWlsJTIwc2Fsb258ZW58MHx8fHwxNzgwMDE3MDUxfDA&ixlib=rb-4.1.0&q=85",
    alt: "Nail salon manicure service",
    category: "service"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Johnson",
    rating: 5,
    text: "Absolutely love this place! The staff is incredibly talented and the atmosphere is so relaxing. My gel manicure lasted 3 weeks without chipping!",
    date: "2 weeks ago"
  },
  {
    id: 2,
    name: "Maria Rodriguez",
    rating: 5,
    text: "Best nail salon in Miami Beach! The Russian manicure is amazing and the attention to detail is unmatched. Highly recommend!",
    date: "1 month ago"
  },
  {
    id: 3,
    name: "Jennifer Lee",
    rating: 5,
    text: "The Luxury Volcano Pedicure is pure heaven! Such a beautiful salon with talented nail artists. I'm a regular now!",
    date: "3 weeks ago"
  },
  {
    id: 4,
    name: "Amanda Torres",
    rating: 4,
    text: "Great service and beautiful nail art designs. The walk-in availability is super convenient for my busy schedule.",
    date: "1 week ago"
  }
];

export const floatingElements = [
  {
    id: 1,
    type: "polish",
    url: "https://images.unsplash.com/photo-1619607146034-5a05296c8f9a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHw0fHxuYWlsJTIwcG9saXNofGVufDB8fHx8MTc4MDAxNzIyMXww&ixlib=rb-4.1.0&q=85",
    alt: "Nail polish bottles"
  }
];

export const bookingSlots = [
  "9:00 AM", "9:30 AM", "10:00 AM", "10:30 AM", "11:00 AM", "11:30 AM",
  "12:00 PM", "12:30 PM", "1:00 PM", "1:30 PM", "2:00 PM", "2:30 PM",
  "3:00 PM", "3:30 PM", "4:00 PM", "4:30 PM", "5:00 PM", "5:30 PM"
];
